// import { LiveCallsService, getUserServices } from "../service/live-calls.service";
import { useEffect, useState } from "react";
import moment from "moment";
import { getUserServices, LiveCallsService } from "./LiveCalls.service";
import Layout from "../layout/Layout";
import { useSearchParams } from "react-router-dom";
import { useDocumentTitle } from "../../utils/Common";
import toast from "react-hot-toast";

export default function LiveCalls() {
  const [searchParams] = useSearchParams();
  const [hasServices, setHasServices] = useState([]);
  const [selectedService, setSelectedService] = useState("");
  const [hasLiveCalls, setHasLiveCalls] = useState([]);
  const [serviceError, setServiceError] = useState("");
  const [notificationReceived, setNotificationReceived] = useState(false);
  const [pacName, setPacName] = useState("");
  const idsParam = searchParams.get("pacIds");

  //   useDocumentTitle('Live Calls');

  useEffect(() => {
    const nameParam = searchParams.get("name");

    if (nameParam) {
      setPacName(decodeURIComponent(nameParam));
    }
  }, [searchParams]);

  // useEffect(() => {
  //   // getUserServices()
  //   //   .then((response) => {
  //   //     const services = response.data.data || [];
  //   //     setHasServices(services);
  //   //     let selectService = "";

  //   // try {
  //   // Only ACTIVE services
  //   // const activeServices = services.filter(
  //   //   item => item.status === "active"
  //   // );

  //   // if (window.location.pathname === "/short-term-investments") {
  //   //   selectService =
  //   //     activeServices.find(item => item.pacFirebaseName === "EP_INVESTORS")?.pacId || "";

  //   // } else if (window.location.pathname === "/option-hedging") {
  //   //   selectService =
  //   //     activeServices.find(item => item.pacFirebaseName === "WEALTHX" || item.pacFirebaseName === "EP_OPTION_HEDGING")?.pacId || "";

  //   // } else if (window.location.pathname === "/opportunities") {
  //   //   selectService =
  //   //     activeServices.find(item => item.pacFirebaseName === "EP_Short_Term_Opportunities")?.pacId || "";

  //   // } else if (window.location.pathname === "/options") {
  //   //   selectService =
  //   //     activeServices.filter(item => item.pacFirebaseName === "EP_INDEX_OPTIONS" || item.pacFirebaseName === "EP_STOCK_OPTION"|| item.pacFirebaseName === "EP_PREMIUM_INDEX_OPTIONS")?.map(item => item.pacId).join(",") || "";
  //   // }

  //   // // ❌ Not subscribed case
  //   // if (!selectService) {
  //   //   throw new Error("NOT_SUBSCRIBED");
  //   // }

  //   // ✅ Subscribed → fetch live calls
  //   //   setServiceError("");
  //   //   LiveCallsService(selectService)
  //   //     .then((response) => {
  //   //       setHasLiveCalls(response.data.data);
  //   //     });

  //   // } catch (error) {
  //   //   console.error(error);
  //   //   setServiceError("You are not subscribed to this service");
  //   //   setHasLiveCalls([]); // clear previous data
  //   // }
  //   // });
  //   const fetchLiveCalls = async () => {
  //     console.log(idsParam, "idsParam -->", typeof idsParam);
  //     const shouldShowToast = notificationReceived;

  //     // ❌ Not subscribed
  //     if (!idsParam || idsParam == "undefined") {
  //       setServiceError("You are not subscribed to this service");
  //       setHasLiveCalls([]);
  //       return;
  //     }

  //     try {
  //       setServiceError("");

  //       const response = await LiveCallsService(idsParam);
  //       setHasLiveCalls(response.data.data || []);
  //       if (shouldShowToast) {
  //         toast.success("Data Fetch Successfully");
  //       }
  //     } catch (error) {
  //       console.error(error);
  //       setServiceError("You are not subscribed to this service");
  //       setHasLiveCalls([]);
  //     } finally {
  //       if (shouldShowToast) {
  //         setNotificationReceived(false);
  //       }
  //     }
  //   };

  //   fetchLiveCalls();
  // }, [notificationReceived]);
    useEffect(() => {
    // getUserServices()
    //   .then((response) => {
    //     const services = response.data.data || [];
    //     setHasServices(services);
    //     let selectService = "";

    // try {
    // Only ACTIVE services
    // const activeServices = services.filter(
    //   item => item.status === "active"
    // );

    // if (window.location.pathname === "/short-term-investments") {
    //   selectService =
    //     activeServices.find(item => item.pacFirebaseName === "EP_INVESTORS")?.pacId || "";

    // } else if (window.location.pathname === "/option-hedging") {
    //   selectService =
    //     activeServices.find(item => item.pacFirebaseName === "WEALTHX" || item.pacFirebaseName === "EP_OPTION_HEDGING")?.pacId || "";

    // } else if (window.location.pathname === "/opportunities") {
    //   selectService =
    //     activeServices.find(item => item.pacFirebaseName === "EP_Short_Term_Opportunities")?.pacId || "";

    // } else if (window.location.pathname === "/options") {
    //   selectService =
    //     activeServices.filter(item => item.pacFirebaseName === "EP_INDEX_OPTIONS" || item.pacFirebaseName === "EP_STOCK_OPTION"|| item.pacFirebaseName === "EP_PREMIUM_INDEX_OPTIONS")?.map(item => item.pacId).join(",") || "";
    // }

    // // ❌ Not subscribed case
    // if (!selectService) {
    //   throw new Error("NOT_SUBSCRIBED");
    // }

    // ✅ Subscribed → fetch live calls
    //   setServiceError("");
    //   LiveCallsService(selectService)
    //     .then((response) => {
    //       setHasLiveCalls(response.data.data);
    //     });

    // } catch (error) {
    //   console.error(error);
    //   setServiceError("You are not subscribed to this service");
    //   setHasLiveCalls([]); // clear previous data
    // }
    // });
    const fetchLiveCalls = async () => {
      console.log(idsParam, "idsParam -->", typeof idsParam);

      // ❌ Not subscribed
      if (!idsParam || idsParam == "undefined") {
        setServiceError("You are not subscribed to this service");
        setHasLiveCalls([]);
        return;
      }

      try {
        setServiceError("");

        const response = await LiveCallsService(idsParam);
        setHasLiveCalls(response.data.data || []);
        toast.success("Data Fetch Successfully");
        setNotificationReceived(false);
      } catch (error) {
        console.error(error);
        setServiceError("You are not subscribed to this service");
        setHasLiveCalls([]);
      }
    };

    fetchLiveCalls();
  }, [notificationReceived]);
  useDocumentTitle(pacName?.trim() ? (pacName == "INVESTOR"? "Investor" : (pacName == "Wealthx Short Term Opportunities"? "Opportunities" : "Options")) : "Live")

  return (
    <Layout>
      <section className="d-none">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="card p-3 mt-lg-5">
                <h6 className="mb-0 fs-24 fw-bold mb-3">Live Calls</h6>
                <div className="row">
                  <div className="col-lg-4 mb-2 d-none">
                    <select
                      className="form-select"
                      onChange={(e) => setSelectedService(e.target.value)}
                    >
                      <option value="">Select a package</option>
                      {(hasServices || []).map((item) => (
                        <option key={item.pacId} value={item.pacId}>
                          {item.pacName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-12">
                    {!serviceError &&
                      (hasLiveCalls || []).map((item, index) => (
                        <div
                          key={index}
                          className={`bg-secondary bg-opacity-10 mb-2 d-flex flex-column rounded-3 py-3 px-2 border-3 border-start w-100 ${item.callType === "MAIN" ? "border-success" : "border-secondary"}`}
                        >
                          {item.callType === "MAIN" ? (
                            <div>
                              <div className="d-flex mb-2">
                                <small className="badge text-success bg-opacity-50">
                                  New Call
                                </small>
                                <small
                                  className="badge bg-opacity-25"
                                  style={{ backgroundColor: "#f55505" }}
                                >
                                  {item.pacInvestmentType}
                                </small>
                                <small className="ms-auto badge text-secondary fw-normal">
                                  {moment(item.epDateTime).format(
                                    "DD MMM YYYY, HH:mm:ss A",
                                  )}
                                </small>
                              </div>
                              <small>
                                {item.serName}: {item.serMsg}
                              </small>
                            </div>
                          ) : (
                            <div>
                              <div className="d-flex mb-2">
                                <small className="badge text-secondary bg-opacity-50">
                                  Follow Up
                                </small>
                                <small
                                  className="badge bg-opacity-25"
                                  style={{ backgroundColor: "#f55505" }}
                                >
                                  {item.pacInvestmentType}
                                </small>
                                <small className="ms-auto badge text-secondary text-uppercase">
                                  {/* {moment(item.epDateTime).format("YYYY-MM-DD HH:MM:SS A")} */}
                                  {moment(item.epDateTime).format(
                                    "DD MMM YYYY, HH:mm:ss A",
                                  )}
                                </small>
                              </div>
                              <small>
                                {item.serName}: {item.serMsg}
                              </small>
                              <div
                                className="bg-primary-subtle p-1 rounded px-3 opacity-75"
                                style={{ fontSize: "14px" }}
                              >
                                <small>
                                  {item.serName}: {item.mainMessage}
                                </small>
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    {!serviceError && hasLiveCalls.length <= 0 && (
                      <div className="mt-4 text-center bg-info rounded py-2 bg-opacity-75">
                        No calls Yet
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="create-portfolio" class="py-3 text-body-emphasis">
        <div class="container">
          <div class="row g-3 justify-content-between mb-3">
            <div class="col-md-12">
              <a
                href="/dashboard"
                class="text-decoration-none text-body-emphasis fs-5"
              >
                <i class="fa fa-arrow-left"></i>
              </a>
            </div>
            <div class="col-md-6">
              <div className="d-flex align-items-baseline gap-2">
                <h4 className="fw-bold mb-0">
                  {pacName?.trim() ? (pacName == "INVESTOR"? "Investor" : (pacName == "Wealthx Short Term Opportunities"? "Opportunities" : "Options")) : "Live"} Recommendations
                </h4>

                {!serviceError && pacName?.trim() && (
                  <button
                    type="button"
                    onClick={() => setNotificationReceived(true)}
                    className="btn btn-md text-primary border-0 shadow-none p-0"
                  >
                    <small>
                      <i className="fa fa-refresh me-1"></i> Refresh
                    </small>
                  </button>
                )}
              </div>
              {!serviceError && (
                <small class="text-muted">
                  {moment().format("DD MMM, YYYY HH:MM A")}
                </small>
              )}
            </div>
          </div>
          <div class="row g-3 justify-content-between">
            <div class="col-md-6">
              {serviceError && (
                <div className="alert alert-warning text-center rounded-3">
                  <i className="fa fa-lock me-2"></i>
                  You are not subscribed to this service
                </div>
              )}
              {!serviceError &&
                (hasLiveCalls || []).map((item, index) =>
                  item.callType !== "MAIN" ? (
                    <div class="border rounded-3 p-2 mb-3">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <small>
                          <small class="bg-warning text-white px-2 py-1 rounded-2">
                            Follow Up
                          </small>
                        </small>
                        <small>
                          <small class="text-muted">
                            {moment(item.epDateTime).format(
                              "DD MMM YYYY, HH:mm:ss A",
                            )}
                          </small>
                        </small>
                      </div>
                      <small>
                        <p class="mb-1">{item.serMsg}</p>
                      </small>
                      <div class="rounded-3 p-2 bg-primary bg-opacity-10 d-inline-block">
                        <small>
                          <div class="d-flex justify-content-between align-items-center">
                            <small class="text-primary d-block pb-1">
                              Main Call
                            </small>
                            {/* <small class="text-muted d-block pb-1">{moment(item.epDateTime).format("DD MMM YYYY, HH:mm:ss A")}</small> */}
                          </div>
                          <small>
                            <p
                              class="mb-1 text-muted"
                              dangerouslySetInnerHTML={{
                                __html: item.mainMessage.replace(
                                  /\n/g,
                                  "<br />",
                                ),
                              }}
                            ></p>
                          </small>
                        </small>
                      </div>
                    </div>
                  ) : (
                    <div class="border rounded-3 p-2 mb-3">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <small>
                          <small class="bg-primary text-white px-2 py-1 rounded-2">
                            New
                          </small>
                        </small>
                        <small>
                          <small class="text-muted">
                            {moment(item.epDateTime).format(
                              "DD MMM YYYY, HH:mm:ss A",
                            )}
                          </small>
                        </small>
                      </div>
                      <small>
                        <p
                          class="mb-1"
                          dangerouslySetInnerHTML={{
                            __html: item.serMsg.replace(/\n/g, "<br />"),
                          }}
                        ></p>
                      </small>
                    </div>
                  ),
                )}
              {!serviceError && hasLiveCalls.length <= 0 && (
                <div className="mt-4 text-center text-muted py-4 border rounded-3 bg-light">
                  <i className="fa fa-bell-slash fs-4 mb-2 d-block"></i>
                  <span className="fw-medium">No live calls yet</span>
                </div>
              )}

            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
